module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/amwayterms/css/fonts/notosanskr/notokr-bold.woff
// module id = O8Py
// module chunks = 0